import { FC } from "react";

type Props = {
	className?: string;
};

const AccountPhotoIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width="44"
			height="44"
			viewBox="0 0 44 44"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			className={className}>
			<g clipPath="url(#clip0_3821_2110)">
				<rect
					width="44"
					height="44"
					rx="22"
					fill="#EAEAEA"
				/>
				<path
					d="M21.9954 26.3999C26.0455 26.3999 29.3288 23.1167 29.3288 19.0666C29.3288 15.0165 26.0455 11.7333 21.9954 11.7333C17.9454 11.7333 14.6621 15.0165 14.6621 19.0666C14.6621 23.1167 17.9454 26.3999 21.9954 26.3999Z"
					fill="#AAAAAA"
				/>
				<path
					d="M21.9961 30.0665C14.6481 30.0665 8.66406 34.9945 8.66406 41.0665C8.66406 41.4772 8.98673 52.7999 9.3974 52.7999H34.5947C35.0054 52.7999 35.3281 41.4772 35.3281 41.0665C35.3281 34.9945 29.3441 30.0665 21.9961 30.0665Z"
					fill="#AAAAAA"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3821_2110">
					<rect
						width="44"
						height="44"
						rx="22"
						fill="white"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default AccountPhotoIcon;
